import { render, staticRenderFns } from "./heroData.vue?vue&type=template&id=2aed89b6&"
import script from "./heroData.vue?vue&type=script&lang=js&"
export * from "./heroData.vue?vue&type=script&lang=js&"
import style0 from "./heroData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports